import { render } from "./App.vue?vue&type=template&id=e8751bf4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e8751bf4&lang=css"
script.render = render

export default script